import styled from 'styled-components';

import { ESpacing } from '@aquariuxfintech/aqx-trader-react-ui/foundation';

export const StyledDemoCompletionDetailsContainer = styled.div`
  padding: ${ESpacing.M}px ${ESpacing.L}px ${ESpacing.XXS}px ${ESpacing.L}px;
  margin-bottom: ${ESpacing.M}px;
  gap: ${ESpacing.M}px;
  display: flex;
  flex-direction: column;
`;
